import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './service/api'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import 'github-markdown-css/github-markdown.css' // 然后添加样式markdown-body


Vue.use(ElementUI);
Vue.use(mavonEditor)

Vue.prototype.Free = window.Free
Vue.prototype.$axios = axios;
Vue.prototype.$emit = Vue.prototype.$emit || function(event, ...args) {
  Vue.prototype.$eventBus = Vue.prototype.$eventBus || new Vue();
  Vue.prototype.$eventBus.$emit(event, ...args);
};
Vue.prototype.$on = Vue.prototype.$on || function(event, handler) {
  Vue.prototype.$eventBus = Vue.prototype.$eventBus || new Vue();
  Vue.prototype.$eventBus.$on(event, handler);
};
Vue.config.productionTip = false


function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
}

router.beforeEach((to, from, next) => {
  console.log(to);
  console.log(from);
  if (to.meta.requireAuth) {
    if (getCookie('server-token')) {
      next();
    } else {
      if (to.path === '/login') {
        next();
      } else {
        next({
          path: '/login'
        })
      }
    }
  }
  else {
    next();
  }
  if (to.fullPath == "/login") {
    if (getCookie('server-token')) {
      next({
        path: from.fullPath
      });
    } else {
      next();
    }
  }
})

router.afterEach(() => {
  document.title = "He Zou";
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
